import React from 'react'
import IcoMoon from './IcoMoon'

// icon from assets/icomoon/selection.js:11475
const display4 = {
  paths: [
    'M1024 832v-768h-1024v768h448v64h-192v64h512v-64h-192v-64h448zM128 192h768v512h-768v-512z',
  ],
  attrs: [],
}

const Display4 = (props) => <IcoMoon icon={ display4 } { ...props } />

export default Display4
